/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AgentType = 'TIME_AGENT' | 'LOCATION_AGENT' | 'BEHAVIOR_AGENT' | 'DEVICE_AGENT';

export const AgentType = {
    TimeAgent: 'TIME_AGENT' as AgentType,
    LocationAgent: 'LOCATION_AGENT' as AgentType,
    BehaviorAgent: 'BEHAVIOR_AGENT' as AgentType,
    DeviceAgent: 'DEVICE_AGENT' as AgentType
};

